var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"background":"#FFFFFF"}},[_c('div',{staticClass:"banner"},[_c('img',{attrs:{"src":require('../../../../assets/img/common/banner_common.png')}})]),_c('br'),_c('br'),_c('honor-img',{attrs:{"list":_vm.certificateList}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }